import { ShoppingCart } from "@mui/icons-material"
import useCategory from "../utils/useCategory"
import useProduct from "../utils/useProduct"
import { iconSx } from "./Cart"
import { txt } from "../../../services/translation"

export default function Total(){

    const category = useCategory()

    const product = useProduct()

    return product && <>

        <div className="apply-cart-footer">

            <ShoppingCart sx={iconSx} />

            <span>{txt('TOTAL')}</span>

            <div className="apply-badge-dark" style={{backgroundColor: category?.color}}>
                
                {['dpc-pi','dpc','opco'].includes(product.variant.id) && 
                    <span>100% pris en charge</span> 
                }

                {['standard','etudiant','fafpm','fifpl'].includes(product.variant.id) && 
                    <span>
                        {product.price.toLocaleString()}€
                    </span>
                }

            </div>

        </div>

    </>
}